/**
 * 此模块为后端返回的响应信息
 */

// 响应信息
const checkMsgList = ["邀请码无效"];

export { checkMsgList };
